import {Component, inject, OnDestroy, OnInit} from "@angular/core";
import {
  ComponentManagerService,
  DataService,
  FormService,
  ModalFormValueChange,
  MultiLineComponentTemplate,
  MultiLineFormModalComponent
} from "@fgpp-ui/components";

@Component({
  selector: 'app-user-amount-limits-modal',
  template : MultiLineComponentTemplate.HTML_TEMPLATE,
  styles: [MultiLineComponentTemplate.STYLE_TEMPLATE],
  providers: [
    FormService,
    ComponentManagerService
  ]
})
export class UserAmountLimitsComponent extends MultiLineFormModalComponent implements OnInit, OnDestroy {

  dataService = inject(DataService);

  formLoadComplete(): void {
    super.formLoadComplete();
    const office = this.data.parentFormData['LIMIT_LEVEL_PROFILE-OFFICE'];
    if (office !== '***') {
      this.formMgr.get('USER_AMOUNT_LIMIT-OFFICE').disable();
      this.formMgr.get('USER_AMOUNT_LIMIT-OFFICE').setValue(office);
      this.setDefaultCurrency(office);
    }
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  protected valueChanges(change: ModalFormValueChange): void {
    if (change.control === 'USER_AMOUNT_LIMIT-OFFICE') {
      const office = this.data.parentFormData['LIMIT_LEVEL_PROFILE-OFFICE'];
      this.setDefaultCurrency(office);
    } else if(change.control === 'USER_AMOUNT_LIMIT-LIMIT_TYPE' && change.value) {
      this.formMgr.get('USER_AMOUNT_LIMIT-STATUSES').reset();
    }
  }

  private setDefaultCurrency(office: string) {
    const url = `/ui/profiles/selectOptions/sqlResource/CURROFFICE`;
     this.dataService.get(url).subscribe((ccyList: Array<any>) => {
       if (Array.isArray(ccyList)) {
         const ccy = ccyList.find(c => c.key === office);
         if (ccy) {
           this.formMgr.get('USER_AMOUNT_LIMIT-LIMIT_CCY').setValue(ccy.value);
         }
       }
     });
  }

  ngOnDestroy(): void {
    super.ngOnDestroy();
  }
}

